module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"cancel":"Назад","browserList":"Необходимо воспользоваться последней версией одного из следующих браузеров:","data":"профиль","permissions":"разрешения","microphone":"настройка микрофона","camera":"настройка камеры","interview":"интервью","candidateAgreed":"кандидат дал согласие на запись интервью","cameraOn":"включите камеру"}}')
  delete Component.options._Ctor
}
